export default __webpack_public_path__ + "static/media/seats.e774af57.png";